import request from '@/utils/request'

export function trackSpm(data) {
  return request({
    url: '/system/spm/track',
    method: 'post',
    data
  })
}

export function trackSpmBatch(dataList) {
  return request({
    url: '/system/spm/track/batch',
    method: 'post',
    data: dataList
  })
}
